import cn from 'classnames';
import React from 'react';

type TestimonialContentProps = {
  content: string
}

export default function TestimonialContent({content}: TestimonialContentProps) {
  const findSeparator = (text: string): string => {
    type Separator = {
      value: string
      tokenLength: number
    }
    const separators: Separator[] = ['.', '!', '?', ';']
      .map((separator) => ({value: separator, tokenLength: text.split(separator, 1)[0].length}));
    const sorted = separators.sort((a, b) => a.tokenLength - b.tokenLength);
    return sorted[0].value;
  }

  const splitContent = (text: string): string[] => {
    const parts: string[] = [];
    const maxLength = 115;
    let currentLength = 0;
    const separator = findSeparator(text);
    const separatorPosition = text.indexOf(separator);
    const splits: string[] = []
    if (separatorPosition < 0) {
      splits.push(text);
    } else {
      splits.push(text.substr(0, separatorPosition + 1));
      splits.push(text.substring(separatorPosition + 1));
    }
    splits.forEach((part) => {
      if (currentLength > maxLength) {
        return;
      }
      currentLength += part.length + 1;
      if (currentLength < maxLength) {
        parts.push(part);
      } else {
        const upTo = maxLength - (currentLength - part.length - 1) + 1;
        parts.push(part.slice(0, upTo).concat('...'));
        return;
      }
    });
    return parts;
  }

  const parts = splitContent(content);

  return (
    <p
      className={cn(content.length <= 46 ? 'text-xl' : 'text-base', 'overflow-hidden')}>
      {parts.map((part, index) => index === 0 ? <span key={index}>{part}</span> :
        <span key={index} className="text-gray">{part}</span>)}
    </p>
  )
}
